/// <amd-module name="Wit/WorkItemForm/Details/WorkItemFormSection" />
import { ErrorBoundary } from "VSS/Platform/Components/ErrorBoundary";
import { css } from "VSSUI/Util";

import { Section } from "Wit/Clients/Wit/Contracts/WorkItemFormLayout";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import * as React from "react";
import { WorkItemFormGroup } from "./WorkItemFormGroup";

export interface IWorkItemFormSectionProps {
    onExtensionLoaded: (workItem: IWorkItem, hostInstance: any) => void;
    gridLayoutEnabled?: boolean;
    keyPrefix: string;
    section: Section;
    wide?: boolean;
    width?: number;
}

export function WorkItemFormSection({ onExtensionLoaded, gridLayoutEnabled = false, keyPrefix, section, wide, width }: IWorkItemFormSectionProps) {
    if (gridLayoutEnabled) {
        return (
            <div
                className="work-item-form-section"
                key={keyPrefix}
            >
                {section.groups
                    .filter(g => g.visible && (g.controls.some(control => control.visible) || g.isContribution))
                    .map(g => {
                        return (
                            <ErrorBoundary handlerComponentType="tfs.page-error-handler" key={keyPrefix + "." + g.id}>
                                <WorkItemFormGroup keyPrefix={g.id} group={g} onExtensionLoaded={onExtensionLoaded} />
                            </ErrorBoundary>
                        );
                    })}
            </div>
        );
    } else {
        return (
            <div
                className={css("inline-flex-column work-item-form-section padding-horizontal-8", wide && "wide")}
                key={keyPrefix}
                style={{ width: `${width}%` }}
            >
                {section.groups
                    .filter(g => g.visible && (g.controls.some(control => control.visible) || g.isContribution))
                    .map(g => {
                        return (
                            <ErrorBoundary handlerComponentType="tfs.page-error-handler" key={keyPrefix + "." + g.id}>
                                <WorkItemFormGroup keyPrefix={g.id} group={g} onExtensionLoaded={onExtensionLoaded} />
                            </ErrorBoundary>
                        );
                    })}
            </div>
        );
    }
}
